// @flow

import React from 'react';
import Button from 'react-aaui/lib/Button';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import { getPassportLink, getEnduranceSignUpLink } from 'modules/app/selector';
import { navToPassport } from 'services/navigation/navigation';
import './SpecialRoleSignUp.scss';

type Props = {
  passportLink: string,
  enduranceSignUpUrl: string
}

class SpecialRoleSignUp extends React.PureComponent<Props> {
    handleTimerClick = () => {
      navToPassport(this.props.passportLink, 'TIMER', '');
    }

    handleEdClick = () => {
      window.open(this.props.enduranceSignUpUrl, '_blank');
    }

    render() {
      return (
        <div className="special-role-sign-up">
          <Row gutter={0} fluid>
            <Col sm={6}>
              <div className="special-role-sign-up__timer">
                <div className="icon"><i className="icon-timer" /></div>
                <div className="title"><L10nMessage id="specialRolesignUp.timer.title" /></div>
                <div className="description">
                  <L10nMessage id="specialRolesignUp.timer.description" />
                </div>
                <Button className="timer-btn" type="super" onClick={this.handleTimerClick}>
                  <L10nMessage id="specialRolesignUp.timer.button" />
                </Button>
              </div>
            </Col>
            <Col sm={6}>
              <div className="special-role-sign-up__ed">
                <div className="icon"><i className="icon-group-thin" /></div>
                <div className="title"><L10nMessage id="specialRolesignUp.ed.title" /></div>
                <div className="description">
                  <L10nMessage id="specialRolesignUp.ed.description" />
                </div>
                <Button className="ed-btn" type="super" onClick={this.handleEdClick}>
                  <L10nMessage id="specialRolesignUp.ed.button" />
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
}

const mapState = (state) => {
  return {
    passportLink: getPassportLink(state),
    enduranceSignUpUrl: getEnduranceSignUpLink(state),
  };
};

export default connect(mapState, null)(SpecialRoleSignUp);
